import { render, staticRenderFns } from "./CustomRadioText.vue?vue&type=template&id=f7697e1e"
import script from "./CustomRadioText.vue?vue&type=script&lang=js"
export * from "./CustomRadioText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports